import { DialogBody } from "@sorcery/ui";
import { RxCross1 } from "react-icons/rx";
import { useModal } from "~/providers/ModalProvider";

export const ContentModal = ({ children }: { children: any }) => {
  const { closeModal } = useModal();
  return (
    <>
      <DialogBody gallery className="w-[calc(100vw-5rem)]">
        <RxCross1
          size={32}
          className="absolute right-10 top-10 cursor-pointer text-white"
          onClick={() => closeModal()}
        />
        {children}
      </DialogBody>
    </>
  );
};
